import { render, staticRenderFns } from "./flexd-side.vue?vue&type=template&id=0930474c&scoped=true&"
import script from "./flexd-side.vue?vue&type=script&lang=ts&"
export * from "./flexd-side.vue?vue&type=script&lang=ts&"
import style0 from "./flexd-side.vue?vue&type=style&index=0&id=0930474c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930474c",
  null
  
)

export default component.exports